export default __webpack_public_path__ + "static/media/fullstack-development.14cc0cc2.svg";